import React from 'react';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function BackToRulesLink() {
  return (
    <MuiLink component={RouterLink} to="/rules" underline="hover" sx={{ whiteSpace: 'nowrap' }}>
      ← Back to All Rules
    </MuiLink>
  );
}
